exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.grid-item[data-v-cffaec02]{\n\tpadding: 10px;\n\tfont-size: 30px;\n\ttext-align: center;\n\twidth:400px;\n\theight:550px;\n}\n.centered[data-v-cffaec02]{\n\tdisplay:flex;\n\tflex-wrap: wrap;\n\tjustify-content:center;\n\tmargin:10px;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":false,"sourceMap":false}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-cffaec02","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/layouts/layout_5.vue
// module id = 765
// module chunks = 0